module.exports = __webpack_public_path__ + "static/tlo3-82f1ff9019f378dbcf1c0ed20c700bdb.webp";